import { useContext, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { AuthContext } from "../App";
import { firebaseAuth } from "../firebaseConfig";
import { signInWithEmailAndPassword } from "firebase/auth";

const Login = () => {

    const navigate = useNavigate();
    const { pAuth, setPAuth, isAdmin, setIsAdmin } = useContext(AuthContext);

    const [formData, setFormData] = useState({
        username: '',
        password: ''
    });

    const SERVER_URL = process.env.NODE_ENV === 'development' ?
        process.env.REACT_APP_DEV_SERVER_URL : process.env.REACT_APP_PROD_SERVER_URL;

    const handleChange = (name, value) => {
        setFormData({ ...formData, [name]: value });
    }

    const handleLoginSubmit = (e) => {
        e.preventDefault();
        let send = JSON.stringify(formData);
        fetch(
            `${SERVER_URL}/dologin`,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'POST',
                credentials: 'include',
                body: send
            },
        ).then(result => result.json())
            .then(data => {
                // first check using passport-local if user is loggedin or not.
                if (data.success) {
                    if (data.user !== null && data.user !== undefined) {
                        // second check if user is registered in firbase also or not.
                        signInWithEmailAndPassword(firebaseAuth, formData.username, formData.password)
                            .then((userCredential) => {
                                // Signed in to firebase
                                const user = userCredential.user;
                                setPAuth(true);
                                alert('Logged in successfully!');
                                navigate('/minganicdashboard');
                            })
                            .catch((error) => {
                                const errorCode = error.code;
                                const errorMessage = error.message;
                                // console.log(errorCode, errorMessage);
                                alert('Log in failed!');
                            });
                    }
                } else {
                    alert('Log in failed!');
                }
            })
            .catch((err) => { console.log(err); alert('Log in failed!'); });
    }

    return (
        <div className="add-project">
            <div className="container">
                <form className="contact-form add-project-form"
                    onSubmit={(e) => { handleLoginSubmit(e) }}>

                    <div className="row px-1 pt-5 pb-3">
                        <p className="m-0 py-0">Sign In</p>
                    </div>

                    <div className="row form-row">
                        <div className="col-12 col-md-6 order-2 order-md-1">
                            <div className="form-box">
                                <label htmlFor="username">Username</label>
                                <input id="username" name="username" type="text" placeholder="Enter Username"
                                    value={formData['username']}
                                    onChange={(e) => handleChange('username', e.target.value)} />
                            </div>

                            <div className="form-box">
                                <label htmlFor="password">Password</label>
                                <input id="password" name="password" type="password" placeholder="Enter Password"
                                    value={formData['password']}
                                    onChange={(e) => handleChange('password', e.target.value)} />
                            </div>

                            <div className="form-box">
                                <button type="submit" className="contact-btn content-2">Sign In<img id="send-arrow" src="/assets/icons/arrow_right_icon.svg" alt="arrow" /></button>
                            </div>

                        </div>

                    </div> {/* end div row */}

                </form>
            </div>
        </div>
    );
}

export default Login;